<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>

  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body: -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Widgets</h5>
                  </div>
                  <small class="text-truncate text-muted">Total 658 (last update 1 month ago)</small>
                </div>
              </div>
            </div>

            <!-- page action  -->
            <div class="col-7 col-xl-8 text-end">

            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-4 py-2">
        <div class="container">

          <!-- Widget: Data card's -->
          <div class="row clearfix">
            <div class="col-12">
              <h5 class="card-title mb-1">Data Card's</h5>
              <p>You can set as per your requirment with real data.</p>
            </div>
          </div>
          <div class="row clearfix">
            <div class="col-lg-3 col-md-6">
              <div class="card mb-4" (click)="openModal(template)" data-bs-toggle="modal"
                data-bs-target="javascript:void(0);w-card-1">
                <div class="card-body">
                  <div class="h2 float-end">27%</div>
                  <h5 class="mb-1">2,510</h5>
                  <div class="text-muted">Total Leads</div>
                  <div class="mt-4">
                    <div class="progress" style="height: 5px;">
                      <div class="progress-bar" role="progressbar" style="width: 27%" aria-valuenow="27"
                        aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
                <!-- Modal -->

                <ng-template #template>
                  <!-- <div class="modal fade" id="w-card-1" tabindex="-1"> -->
                  <!-- <div class="modal-dialog modal-xl">
                    <div class="modal-content"> -->
                  <div class="modal-header">
                    <h5 class="modal-title pull-left" style="font-family: 'IBM Plex Sans', sans-serif;">Widget HTML code
                    </h5>
                    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <pre><code class="language-html">
                            &lt;div class=&quot;card mb-4&quot;&gt;
                                &lt;div class=&quot;card-body&quot;&gt;
                                    &lt;div class=&quot;h2 float-end&quot;&gt;27%&lt;/div&gt;
                                    &lt;h5 class=&quot;mb-1&quot;&gt;2,510&lt;/h5&gt;
                                    &lt;div class=&quot;text-muted&quot;&gt;Total Leads&lt;/div&gt;
                                    &lt;div class=&quot;mt-4&quot;&gt;
                                        &lt;div class=&quot;progress&quot; style=&quot;height: 5px;&quot;&gt;
                                            &lt;div class=&quot;progress-bar&quot; role=&quot;progressbar&quot; style=&quot;width: 27%&quot; aria-valuenow=&quot;27&quot; aria-valuemin=&quot;0&quot; aria-valuemax=&quot;100&quot;&gt;&lt;/div&gt;
                                        &lt;/div&gt;
                                    &lt;/div&gt;
                                &lt;/div&gt;
                            &lt;/div&gt;</code></pre>
                  </div>
                  <!-- </div>
                  </div> -->
                  <!-- </div> -->
                </ng-template>


              </div>
              <div class="card p-3 px-4 mb-4">
                <div>Total revenue</div>
                <div class="py-4 m-0 text-center h1 text-success">$9,452</div>
                <div class="d-flex">
                  <small class="text-muted">Income</small>
                  <div class="ms-auto"><i class="zmdi zmdi-trending-up text-success me-2"></i>4%</div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <h6 class="text-muted text-uppercase mt-0">Orders</h6>
                  <h2>1,587</h2>
                  <span class="badge bg-primary">+11% </span>
                  <span class="text-muted">From previous period</span>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body media">
                  <div class="avatar me-3">
                    <div class="avatar rounded-circle no-image orange">
                      <span><i class="zmdi zmdi-label"></i></span>
                    </div>
                  </div>
                  <div class="media-body overflow-hidden">
                    <span>Bounce rate</span>
                    <h5 class="mb-0">52.5</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card p-3 px-4 mb-4">
                <div>Income status</div>
                <div class="py-4 m-0 text-center h1 text-info">$2,258</div>
                <div class="d-flex">
                  <small class="text-muted">New income</small>
                  <div class="ms-auto">0%</div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <div class="h2 float-end">62%</div>
                  <h5 class="mb-1">Server</h5>
                  <div class="text-muted">of 1Tb</div>
                  <div class="mt-4">
                    <div class="progress" style="height: 5px;">
                      <div class="progress-bar bg-warning" role="progressbar" style="width: 65%" aria-valuenow="65"
                        aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body media">
                  <div class="avatar me-3">
                    <div class="avatar rounded-circle no-image green">
                      <span><i class="zmdi zmdi-balance"></i></span>
                    </div>
                  </div>
                  <div class="media-body overflow-hidden">
                    <span>Total income</span>
                    <h5 class="mb-0">$7,805</h5>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <h6 class="text-muted text-uppercase mt-0">Product Sold</h6>
                  <h2>2,248</h2>
                  <span class="badge bg-success">+19% </span>
                  <span class="text-muted">Last year</span>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="card mb-4">
                <div class="card-body">
                  <div class="h2 float-end">45%</div>
                  <h5 class="mb-1">Email</h5>
                  <div class="text-muted">Total Account</div>
                  <div class="mt-3">
                    <div class="progress" style="height: 5px;">
                      <div class="progress-bar bg-success" role="progressbar" style="width: 45%" aria-valuenow="45"
                        aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Users Overview</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-6 border-end">
                      <small>New Users</small>
                      <h4 class="fw-bold">2,025</h4>
                    </div>
                    <div class="col-6">
                      <small>Return Visitors</small>
                      <h4 class="fw-bold">1,254</h4>
                    </div>
                  </div>
                  <hr>
                  <div class="mb-3">
                    <label class="d-block">New Users <span class="float-end">77%</span></label>
                    <div class="progress" style="height: 2px;">
                      <div class="progress-bar bg-success" role="progressbar" aria-valuenow="77" aria-valuemin="0"
                        aria-valuemax="100" style="width: 77%;"></div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="d-block">Return Visitors <span class="float-end">50%</span></label>
                    <div class="progress" style="height: 2px;">
                      <div class="progress-bar bg-warning" role="progressbar" aria-valuenow="50" aria-valuemin="0"
                        aria-valuemax="100" style="width: 50%;"></div>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label class="d-block">Engagement <span class="float-end">23%</span></label>
                    <div class="progress" style="height: 2px;">
                      <div class="progress-bar progbgress-info" role="progressbar" aria-valuenow="23" aria-valuemin="0"
                        aria-valuemax="100" style="width: 23%;"></div>
                    </div>
                  </div>
                  <small class="font-12">The total number of Page Impressions within the date range<a href="">View
                      more</a></small>
                </div>
              </div>
              <div class="row clearfix">
                <div class="col-lg-6 col-md-6">
                  <div class="card mb-4">
                    <div class="card-body media">
                      <div class="avatar me-3">
                        <div class="avatar rounded-circle no-image red">
                          <span><i class="zmdi zmdi-card"></i></span>
                        </div>
                      </div>
                      <div class="media-body overflow-hidden">
                        <span>New expense</span>
                        <h5 class="mb-0">$5,805</h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-md-6">
                  <div class="card mb-4">
                    <div class="card-body media">
                      <div class="avatar me-3">
                        <div class="avatar rounded-circle no-image timber">
                          <span><i class="zmdi zmdi-accounts"></i></span>
                        </div>
                      </div>
                      <div class="media-body overflow-hidden">
                        <span>Daily Visits</span>
                        <h5 class="mb-0">15,805</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Widget: List card's -->
          <div class="row clearfix mt-5">
            <div class="col-12">
              <h5 class="card-title mb-1">List Card's</h5>
              <p>You can set as per your requirment with real data.</p>
            </div>
          </div>
          <div class="row clearfix">
            <div class="col-lg-12 col-md-12">
              <div class="card mb-4">
                <div class="card-body pb-0">
                  <div class="row align-items-center">
                    <div class="col text-truncate">
                      <div class="d-flex align-items-center">
                        <img src="assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip" title="" alt="Avatar"
                          class="rounded-circle avatar" data-original-title="Avatar Name">
                        <div class="ms-3">
                          <a href="app-project-invoice-detail.html" title="">Kevin Gill</a>
                          <p class="mb-0">kevin.gill@example.com</p>
                        </div>
                      </div>
                    </div>
                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                          class="btn btn-link btn-sm dropdown-toggle">
                          <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                        </button>
                        <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-basic">
                          <a href="javascript:void(0);" class="dropdown-item">Action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ul class="nav nav-tabs tab-custom tab-sm mt-4 border-0" role="tablist">
                    <li class="nav-item">
                      <a class="nav-link active" href="javascript:void(0)" (click)="onMenuTab('1')"
                        [ngClass]="{'active': inboxTab}">
                        <span class="d-block d-md-none"><i class="zmdi zmdi-email"></i></span>
                        <span class="d-none d-md-block"> INBOX</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('2')"
                        [ngClass]="{'active': sentTab}">
                        <span class="d-block d-md-none"><i class="zmdi zmdi-mail-send"></i></span>
                        <span class="d-none d-md-block">SENT</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('3')"
                        [ngClass]="{'active': spamTab}">
                        <span class="d-block d-md-none"><i class="zmdi zmdi-block"></i></span>
                        <span class="d-none d-md-block">SPAM</span>
                      </a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" href="javascript:void(0)" (click)="onMenuTab('4')"
                        [ngClass]="{'active': deleteTab}">
                        <span class="d-block d-md-none"><i class="zmdi zmdi-delete"></i></span>
                        <span class="d-none d-md-block">DELETED</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="tab-content">
                  <div class="tab-pane fade active show" [ngClass]="{'show active': inboxTab}" id="inbox"
                    aria-labelledby="inbox-tab" role="tabpanel">
                    <div class="row p-4 no-gutters align-items-center border-bottom">
                      <div class="col-sm-12 col-md-6">
                        <h4 class=" mb-0">145 Unread emails</h4>
                      </div>
                      <div class="col-sm-12 col-md-6 text-end">
                        <div class="btn-group">
                          <button type="button" class="btn btn-primary">Compose</button>
                          <button type="button" class="btn btn-danger">Delete</button>
                        </div>
                      </div>
                    </div>
                    <!-- Mail list-->
                    <div class="list-group custom list-group-flush mail-list-widget">
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Work</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Michelle Green</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Business</span>
                              <span class="text-muted">Regarding our meeting – There are many variations of
                                passages</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Jason Porter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-success me-1">Friend</span>
                              <span class="text-muted">Hey, You wanna join me and Fred at the lake tomorrow?</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">David Wallace</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-warning me-1">Domain</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Grace Knight</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-info me-1">HR</span>
                              <span class="text-muted">There are many variations of passages of Lorem Ipsum
                                available</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-danger me-1">Support</span>
                              <span class="text-muted">Hello - That's great, see you on Thursday!</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                    </div>
                  </div>
                  <div class="tab-pane fade" [ngClass]="{'show active': sentTab}" id="sent" aria-labelledby="sent-tab"
                    role="tabpanel">
                    <div class="row p-4 no-gutters align-items-center border-bottom">
                      <div class="col-sm-12 col-md-6">
                        <h4 class=" mb-0">78 emails</h4>
                      </div>
                      <div class="col-sm-12 col-md-6 text-end">
                        <div class="btn-group">
                          <button type="button" class="btn btn-primary">Compose</button>
                          <button type="button" class="btn btn-danger">Delete</button>
                        </div>
                      </div>
                    </div>

                    <!-- Mail list-->
                    <div class="list-group custom list-group-flush mail-list-widget">
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Work</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">Michelle Green</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Business</span>
                              <span class="text-muted">Regarding our meeting – There are many variations of
                                passages</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Jason Porter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-success me-1">Friend</span>
                              <span class="text-muted">Hey, You wanna join me and Fred at the lake tomorrow?</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star"></i></div>
                          <div class="px-1 text-truncate user-name">David Wallace</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-warning me-1">Domain</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Grace Knight</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-info me-1">HR</span>
                              <span class="text-muted">There are many variations of passages of Lorem Ipsum
                                available</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-danger me-1">Support</span>
                              <span class="text-muted">Hello - That's great, see you on Thursday!</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                    </div>
                  </div>
                  <div class="tab-pane fade" [ngClass]="{'show active': spamTab}" id="spam" aria-labelledby="spam-tab"
                    role="tabpanel">
                    <div class="row p-4 no-gutters align-items-center border-bottom">
                      <h3>No spam eamil</h3>
                    </div>
                  </div>
                  <div class="tab-pane fade" [ngClass]="{'show active': deleteTab}" id="delete"
                    aria-labelledby="delete-tab" role="tabpanel">
                    <div class="row p-4 no-gutters align-items-center border-bottom">
                      <div class="col-sm-12 col-md-6">
                        <h4 class=" mb-0"><i class="me-2"></i>78 emails</h4>
                      </div>
                      <div class="col-sm-12 col-md-6 text-end">
                        <div class="btn-group">
                          <button type="button" class="btn btn-primary">Compose</button>
                          <button type="button" class="btn btn-danger">Delete</button>
                        </div>
                      </div>
                    </div>

                    <!-- Mail list-->
                    <div class="list-group custom list-group-flush mail-list-widget">
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Work</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Michelle Green</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-primary me-1">Business</span>
                              <span class="text-muted">Regarding our meeting – There are many variations of
                                passages</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Jason Porter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-success me-1">Friend</span>
                              <span class="text-muted">Hey, You wanna join me and Fred at the lake tomorrow?</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">David Wallace</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-warning me-1">Domain</span>
                              <span class="text-muted">Lorem ipsum perspiciatis</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Grace Knight</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-info me-1">HR</span>
                              <span class="text-muted">There are many variations of passages of Lorem Ipsum
                                available</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                      <li class="list-group-item list-group-item-action">
                        <div class="d-flex">
                          <div>
                            <label class="c_checkbox">
                              <input type="checkbox">
                              <span class="ms-2 todo_name"></span>
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div class="px-1 d-none d-md-block"><i class="zmdi zmdi-star text-warning"></i></div>
                          <div class="px-1 text-truncate user-name">Terry Carter</div>
                          <div class="px-1 flex-grow-1 text-truncate">
                            <a class="link" href="javascript: void(0)">
                              <span class="badge bg-danger me-1">Support</span>
                              <span class="text-muted">Hello - That's great, see you on Thursday!</span>
                            </a>
                          </div>
                          <div class="px-3 d-none d-md-block"><i class="zmdi zmdi-attachment-alt text-muted"></i></div>
                          <div class="date"><small>May 13</small></div>
                        </div>
                      </li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Overall Rating</h6>
                </div>
                <div class="card-body">
                  <div class="d-flex align-items-end">
                    <h2 class="mb-0">4.3</h2>
                    <div class="ms-2 me-2">
                      <i class="zmdi zmdi-star"></i>
                      <i class="zmdi zmdi-star"></i>
                      <i class="zmdi zmdi-star"></i>
                      <i class="zmdi zmdi-star"></i>
                      <i class="zmdi zmdi-star-outline"></i>
                    </div>
                  </div>
                  <div class="avatar-list avatar-list-stacked mt-3">
                    <img class="avatar sm" src="assets/images/xs/avatar5.jpg" data-bs-toggle="tooltip" title=""
                      data-original-title="Avatar">
                    <img class="avatar sm" src="assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip" title=""
                      data-original-title="Avatar">
                    <img class="avatar sm" src="assets/images/xs/avatar1.jpg" data-bs-toggle="tooltip" title=""
                      data-original-title="Avatar">
                    <img class="avatar sm" src="assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip" title=""
                      data-original-title="Avatar">
                  </div>
                  <ul class="list-group custom list-group-flush ratings font-13 mt-3">
                    <li class="list-group-item d-flex pl-0 pr-0 py-2">
                      <div>5.0</div>
                      <div class="stars ms-2 me-2">
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                      </div>
                      <div class="ms-auto">
                        <span>4,178</span>
                        <small>58%</small>
                      </div>
                    </li>
                    <li class="list-group-item d-flex pl-0 pr-0 py-2">
                      <div>4.0</div>
                      <div class="stars ms-2 me-2">
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                      </div>
                      <div class="ms-auto">
                        <span>2,091</span>
                        <small>28%</small>
                      </div>
                    </li>
                    <li class="list-group-item d-flex pl-0 pr-0 py-2">
                      <div>3.0</div>
                      <div class="stars ms-2 me-2">
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                      </div>
                      <div class="ms-auto">
                        <span>984</span>
                        <small>15%</small>
                      </div>
                    </li>
                    <li class="list-group-item d-flex pl-0 pr-0 py-2">
                      <div>2.0</div>
                      <div class="stars ms-2 me-2">
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                      </div>
                      <div class="ms-auto">
                        <span>430</span>
                        <small>8%</small>
                      </div>
                    </li>
                    <li class="list-group-item d-flex pl-0 pr-0 py-2">
                      <div>1.0</div>
                      <div class="stars ms-2 me-2">
                        <i class="zmdi zmdi-star"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                        <i class="zmdi zmdi-star-outline"></i>
                      </div>
                      <div class="ms-auto">
                        <span>307</span>
                        <small>18%</small>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <h6 class="card-title">Browser Stats</h6>
                  <table class="table mb-0 mt-4">
                    <tbody>
                      <tr>
                        <td>Google Chrome</td>
                        <td class="text-end"><span class="badge bg-info">40%</span></td>
                      </tr>
                      <tr>
                        <td>Mozila Firefox</td>
                        <td class="text-end"><span class="badge bg-danger">30%</span></td>
                      </tr>
                      <tr>
                        <td>Safari</td>
                        <td class="text-end"><span class="badge bg-primary">15%</span></td>
                      </tr>
                      <tr>
                        <td>Opera</td>
                        <td class="text-end"><span class="badge bg-primary">15%</span></td>
                      </tr>
                      <tr>
                        <td>Internet Explorer</td>
                        <td class="text-end"><span class="badge bg-warning">15%</span></td>
                      </tr>
                      <tr>
                        <td>Microsoft edge</td>
                        <td class="text-end"><span class="badge bg-warning">15%</span></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Top Countries</h6>
                </div>
                <table class="table table-hover mb-0">
                  <tbody>
                    <tr>
                      <td>
                        USA
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 78%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$6425</span></td>
                    </tr>
                    <tr>
                      <td>
                        Poland
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 62%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$5582</span></td>
                    </tr>
                    <tr>
                      <td>
                        Germany
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 48%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$4587</span></td>
                    </tr>
                    <tr>
                      <td>
                        Russia
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 35%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$2520</span></td>
                    </tr>
                    <tr>
                      <td>
                        Australia
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 30%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$1899</span></td>
                    </tr>
                    <tr>
                      <td>
                        Great Britain
                        <div class="progress mt-1" style="height: 2px;">
                          <div class="progress-bar" style="width: 22%"></div>
                        </div>
                      </td>
                      <td class="text-end"><span class="text-muted">$1056</span></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <h6 class="card-title">Recent Followers</h6>
                  <form>
                    <div class="input-group mb-4">
                      <input type="text" class="form-control" placeholder="Search...">
                    </div>
                  </form>

                  <ul class="right_chat list-unstyled">
                    <li class="mb-3">
                      <a href="javascript:void(0);" class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="assets/images/xs/avatar1.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <p class="text-truncate mb-0 me-auto">Michelle Green</p>
                          <small class="text-truncate text-muted">Designer, Blogger</small>
                        </div>
                      </a>
                    </li>
                    <li class="mb-3">
                      <a href="javascript:void(0);" class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="assets/images/xs/avatar2.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <p class="text-truncate mb-0 me-auto">Folisise Chosielie</p>
                          <small class="text-truncate">Java Developer</small>
                        </div>
                      </a>
                    </li>
                    <li class="mb-3">
                      <a href="javascript:void(0);" class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="assets/images/xs/avatar3.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <p class="text-truncate mb-0 me-auto">Sean Black</p>
                          <small class="text-truncate">Designer, Blogger</small>
                        </div>
                      </a>
                    </li>
                    <li class="mb-3">
                      <a href="javascript:void(0);" class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="assets/images/xs/avatar5.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <p class="text-truncate mb-0 me-auto">Terry Carter</p>
                          <small class="text-truncate">Designer, Blogger</small>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0);" class="media">
                        <div class="avatar me-3">
                          <img class="avatar rounded-circle" src="assets/images/xs/avatar4.jpg" alt="avatar">
                        </div>
                        <div class="media-body overflow-hidden">
                          <p class="text-truncate mb-0 me-auto">Michelle Schultz</p>
                          <small class="text-truncate">Writter, Mag Editor</small>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="card mb-4">
                <div class="card-header">
                  <h6 class="card-title mb-0">Files list</h6>
                </div>
                <ul class="list-group custom list-group-flush">
                  <li class="list-group-item py-2">
                    <div class="attachment">
                      <div class="media mt-2">
                        <div class="avatar me-2">
                          <div class="avatar rounded no-image orange">
                            <i class="zmdi zmdi-collection-pdf"></i>
                          </div>
                        </div>
                        <div class="media-body overflow-hidden">
                          <h6 class="text-truncate mb-0">Design file.pdf</h6>
                          <span class="file-size">2.7 mb</span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item py-2">
                    <div class="attachment">
                      <div class="media mt-2">
                        <div class="avatar me-2">
                          <div class="avatar rounded no-image cyan">
                            <i class="zmdi zmdi-file"></i>
                          </div>
                        </div>
                        <div class="media-body overflow-hidden">
                          <h6 class="text-truncate mb-0">Design file.psd</h6>
                          <span class="file-size">22.5 mb</span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item py-2">
                    <div class="attachment">
                      <div class="media mt-2">
                        <div class="avatar me-2">
                          <div class="avatar rounded no-image green">
                            <i class="zmdi zmdi-file-text"></i>
                          </div>
                        </div>
                        <div class="media-body overflow-hidden">
                          <h6 class="text-truncate mb-0">Project detail.doc</h6>
                          <span class="file-size">2.8 mb</span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item py-2">
                    <div class="attachment">
                      <div class="media mt-2">
                        <div class="avatar me-2">
                          <div class="avatar rounded no-image orange">
                            <i class="zmdi zmdi-collection-pdf"></i>
                          </div>
                        </div>
                        <div class="media-body overflow-hidden">
                          <h6 class="text-truncate mb-0">Design file.pdf</h6>
                          <span class="file-size">2.7 mb</span>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="list-group-item py-2">
                    <div class="attachment">
                      <div class="media mt-2">
                        <div class="avatar me-2">
                          <div class="avatar rounded no-image cyan">
                            <i class="zmdi zmdi-file"></i>
                          </div>
                        </div>
                        <div class="media-body overflow-hidden">
                          <h6 class="text-truncate mb-0">Design file.psd</h6>
                          <span class="file-size">22.5 mb</span>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <h6 class="card-title">My Stats</h6>
                  <ul class="list-group custom list-group-flush mt-4">
                    <li class="px-0 list-group-item d-flex justify-content-between align-items-center"><span><i
                          class="icon-book-open me-1"></i> Active Projects</span> <span
                        class="badge bg-primary ms-auto">21</span></li>
                    <li class="px-0 list-group-item d-flex justify-content-between align-items-center"><span><i
                          class="icon-list me-1"></i> Task Pending</span> <span class="badge bg-info">50</span></li>
                    <li class="px-0 list-group-item d-flex justify-content-between align-items-center"><span><i
                          class="fa fa-ticket me-1"></i> Support Tickets</span> <span class="bg-success badge">9</span>
                    </li>
                    <li class="px-0 list-group-item d-flex justify-content-between align-items-center"><span><i
                          class="icon-tag me-1"></i> New Projects</span> <span class="bg-info badge">7</span></li>
                    <li class="px-0 list-group-item d-flex justify-content-between align-items-center"><span><i
                          class="icon-list me-1"></i> Task Pending</span> <span class="badge bg-info">50</span></li>
                    <li class="px-0 list-group-item d-flex justify-content-between align-items-center"><span><i
                          class="fa fa-ticket me-1"></i> Support Tickets</span> <span class="bg-success badge">9</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Widget: user card -->
          <div class="row clearfix mt-5">
            <div class="col-12">
              <h5 class="card-title mb-1">User Card's</h5>
              <p>You can set as per your requirment with real data.</p>
            </div>
          </div>
          <div class="row clearfix">
            <div class="col-12">
              <div class="card mb-4">
                <div class="card-body">
                  <div class="row align-items-center">
                    <!-- Avatar -->
                    <div class="col-auto">
                      <a href="javascript:void(0);" class="avatar"><img src="assets/images/xs/avatar1.jpg" alt="..."
                          class="rounded-circle"></a>
                    </div>

                    <div class="col ml-n2">
                      <!-- Title -->
                      <h5 class="mb-1"><a href="javascript:void(0);">Michelle Green</a></h5>
                      <!-- Text -->
                      <p class="small text-muted mb-1">You either die Spongebob or you live long enough to...</p>
                      <!-- Status -->
                      <p class="small mb-0"><span class="text-success">●</span> Online</p>
                    </div>

                    <!-- Button -->
                    <div class="col-auto">
                      <a href="javascript:void(0);"
                        class="btn btn-sm btn-primary d-none d-md-inline-block">Subscribe</a>
                    </div>

                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown placement="bottom right">
                        <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                          class="btn btn-link btn-sm dropdown-toggle">
                          <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                        </button>
                        <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-basic">
                          <a href="javascript:void(0);" class="dropdown-item">Action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>

                  </div> <!-- / .row -->
                </div> <!-- / .card-body -->
              </div>
            </div>

            <div class="col-lg-5 col-md-6">
              <div class="card mb-4">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col text-truncate">
                      <div class="d-flex align-items-center">
                        <img src="assets/images/xs/avatar6.jpg" data-bs-toggle="tooltip" title="" alt="Avatar"
                          class="rounded-circle avatar" data-original-title="Avatar Name">
                        <div class="ms-3">
                          <a href="javascript:void(0);" title="">Kevin Gill</a>
                          <p class="mb-0">kevin.gill@example.com</p>
                        </div>
                      </div>
                    </div>
                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown>
                        <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                          class="btn btn-link btn-sm dropdown-toggle">
                          <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                        </button>
                        <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                          aria-labelledby="button-basic">
                          <a href="javascript:void(0);" class="dropdown-item">Action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-group mt-3">
                    <textarea rows="3" class="form-control no-resize"
                      placeholder="Please type what you want..."></textarea>
                  </div>
                  <div class="text-end">
                    <button class="btn btn-primary">Post</button>
                    <button class="btn btn-link"><i class="zmdi zmdi-attachment text-muted"></i></button>
                    <button class="btn btn-link"><i class="zmdi zmdi-camera text-muted"></i></button>
                    <button class="btn btn-link"><i class="zmdi zmdi-mood text-muted"></i></button>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body text-center">
                  <div><img src="assets/images/sm/avatar3.jpg" class="rounded-circle img-thumbnail" alt="profile-image">
                  </div>
                  <div class="mt-3">
                    <h5>Freddie J. Plourde</h5>
                    <p class="text-muted">@Founder <span>| </span><span><a href="javascript:void(0);"
                          class="text-pink">websitename.com</a></span></p>
                  </div>
                  <ul class="social-links list-inline mb-4">
                    <li class="list-inline-item"><a title="" data-placement="top" data-bs-toggle="tooltip"
                        class="tooltips" href="" data-original-title="Facebook"><i
                          class="zmdi zmdi-instagram zmdi-hc-lg"></i></a></li>
                    <li class="list-inline-item"><a title="" data-placement="top" data-bs-toggle="tooltip"
                        class="tooltips" href="" data-original-title="linkedin"><i
                          class="zmdi zmdi-linkedin-box zmdi-hc-lg"></i></a></li>
                    <li class="list-inline-item"><a title="" data-placement="top" data-bs-toggle="tooltip"
                        class="tooltips" href="" data-original-title="twitter"><i
                          class="zmdi zmdi-twitter-box zmdi-hc-lg"></i></a></li>
                  </ul>
                  <button type="button" class="btn btn-primary">Message Now</button>
                </div>
                <div class="card-footer text-center">
                  <div class="row">
                    <div class="col-4">
                      <h6 class="mb-1">2563</h6>
                      <small class="mb-0 text-muted">Wallets Balance</small>
                    </div>
                    <div class="col-4">
                      <h6 class="mb-1">6952</h6>
                      <small class="mb-0 text-muted">Income amounts</small>
                    </div>
                    <div class="col-4">
                      <h6 class="mb-1">1125</h6>
                      <small class="mb-0 text-muted">Total Transactions</small>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <article class="media mb-0">
                    <div class="me-3">
                      <img class="rounded" src="assets/images/xs/avatar4.jpg" alt="">
                    </div>
                    <div class="media-body">
                      <div class="content">
                        <p class="h6">John Smith <small>@johnsmith</small></p>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit Aenean efficitur.</p>
                      </div>
                      <nav class="d-flex text-muted font-13">
                        <a href="javascript:void(0);" class="icon me-3"><i class="me-1 zmdi zmdi-replay"></i></a>
                        <a href="javascript:void(0);" class="icon me-3"><i class="me-1 zmdi zmdi-twitter"></i>24</a>
                        <a href="javascript:void(0);" class="icon me-3"><i class="me-1 zmdi zmdi-favorite"></i>43</a>
                        <a href="javascript:void(0);" class="text-muted ms-auto">5 notes</a>
                      </nav>
                    </div>
                  </article>
                </div>
              </div>
              <div class="card mb-4 overflow-hidden">
                <div class="bg-primary d-flex flex-column">
                  <div class="p-3 d-flex justify-content-between align-items-center">
                    <h5 class="mb-0 text-white">Basic Card</h5>
                    <div class="dropdown d-inline-block" dropdown placement="bottom right">
                      <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                        class="btn btn-link btn-sm dropdown-toggle text-white">
                        <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                      </button>
                      <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                        aria-labelledby="button-basic">
                        <a href="javascript:void(0);" class="dropdown-item">Action</a>
                        <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                        <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                        <div class="dropdown-divider"></div>
                        <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                      </div>
                    </div>
                  </div>
                  <div class="py-5 text-center">
                    <div class="h1 text-white">$325,054</div>
                  </div>
                </div>
                <div class="card border-0">
                  <div class="card-header d-flex align-items-stretch pb-0">
                    <ul class="nav nav-tabs page-header-tabs border-bottom-0">
                      <li class="nav-item"><a class="nav-link active" href="javascript:void(0);"
                          data-bs-toggle="tab">History</a></li>
                      <li class="nav-item dropdown" dropdown placement="bottom right">
                        <a class="nav-link dropdown-toggle" id="button-basic" dropdownToggle type="button"
                          aria-controls="dropdown-basic">Dropdown</a>
                        <div id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                          aria-labelledby="button-basic">
                          <a href="javascript:void(0);" class="dropdown-item">Action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                          <div class="dropdown-divider"></div>
                          <a class="dropdown-item" href="javascript: void(0)">Separated link</a>
                        </div>
                      </li>
                      <li class="nav-item"><a class="nav-link" href="javascript:void(0);"
                          data-bs-toggle="tab">Actions</a></li>
                    </ul>
                  </div>
                  <div class="card-body">
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                      the
                      industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                      and scrambled it to make a type specimen book.</p>
                    <p> It has survived not only five centuries, but also the leap into electronic typesetting,
                      remaining
                      essentially unchanged.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-6">
              <div class="card mb-4">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col text-truncate">
                      <div class="d-flex align-items-center">
                        <img src="assets/images/xs/avatar4.jpg" data-bs-toggle="tooltip" title="" alt="Avatar"
                          class="rounded-circle avatar" data-original-title="Avatar Name">
                        <div class="ms-3">
                          <a href="app-project-invoice-detail.html" title="">Kevin Gill</a>
                          <p class="mb-0">kevin.gill@example.com</p>
                        </div>
                      </div>
                    </div>
                    <!-- Dropdown -->
                    <div class="col-auto">
                      <div class="dropdown" dropdown>
                        <button id="button-basic" dropdownToggle type="button" aria-controls="dropdown-basic"
                          class="btn btn-link btn-sm dropdown-toggle">
                          <i class="zmdi zmdi-more-vert zmdi-hc-lg"></i>
                        </button>
                        <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                          aria-labelledby="button-basic">
                          <a href="javascript:void(0);" class="dropdown-item">Action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Another action</a>
                          <a href="javascript:void(0);" class="dropdown-item">Something else here</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <div class="media">
                    <div class="avatar me-3">
                      <div class="avatar rounded-circle no-image timber">
                        <span>UD</span>
                      </div>
                    </div>
                    <div class="media-body overflow-hidden">
                      <div class="d-flex align-items-center justify-content-between mb-1">
                        <h6 class="text-truncate mb-0 me-auto">UI-Design Group</h6>
                      </div>
                      <div class="text-truncate">
                        <i class="zmdi zmdi-file-text me-1"></i> North Carolina, CT
                        <div class="avatar-list avatar-list-stacked mt-1">
                          <img class="avatar xs rounded" src="../dist/assets/images/xs/avatar5.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Sean">
                          <img class="avatar xs rounded" src="../dist/assets/images/xs/avatar6.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Martin">
                          <img class="avatar xs rounded" src="../dist/assets/images/xs/avatar1.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Terry">
                          <img class="avatar xs rounded" src="../dist/assets/images/xs/avatar4.jpg"
                            data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Michelle">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4 text-center">
                <div class="card-body ">
                  <div class="avatar lg ms-auto me-auto">
                    <div class="avatar lg rounded-circle no-image timber">
                      <span>UD</span>
                    </div>
                  </div>
                  <div class="overflow-hidden mt-4">
                    <h6 class="text-truncate">UI-Design Group</h6>
                    <div class="text-truncate">
                      <i class="zmdi zmdi-file-text me-1"></i> North Carolina, CT
                      <div class="avatar-list avatar-list-stacked mt-1">
                        <img class="avatar xs rounded" src="../dist/assets/images/xs/avatar5.jpg"
                          data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Sean">
                        <img class="avatar xs rounded" src="../dist/assets/images/xs/avatar6.jpg"
                          data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Martin">
                        <img class="avatar xs rounded" src="../dist/assets/images/xs/avatar1.jpg"
                          data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Terry">
                        <img class="avatar xs rounded" src="../dist/assets/images/xs/avatar4.jpg"
                          data-bs-toggle="tooltip" data-placement="top" title="" data-original-title="Michelle">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <img src="assets/images/gallery/1.jpg" class="card-img-top" alt="...">
                <div class="card-body">
                  <h5 class="card-title">Card title</h5>
                  <p class="card-text">Some quick example text to build on the card title and make up the bulk of the
                    card's content.</p>
                </div>
                <ul class="list-group custom list-group-flush">
                  <li class="list-group-item">Cras justo odio</li>
                  <li class="list-group-item">Vestibulum at eros</li>
                </ul>
                <div class="card-body">
                  <a href="javascript:void(0);" class="card-link">Card link</a>
                  <a href="javascript:void(0);" class="card-link">Another link</a>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body text-center">
                  <div class="h2 fw-bold">$45,854</div>
                  <p class="text-uppercase text-muted mb-3">Revenue today</p>
                  <p class="mb-4">Lorem ipsum dolor sit amit,consectetur eiusmdd tempory incididunt ut labore et dolore
                    magna elit</p>
                  <a href="javascript:void(0);" class="btn btn-outline-primary mb-1">View history</a>
                </div>
              </div>
              <div class="card p-4 mb-4">
                <div class="d-flex flex-nowrap align-items-center flex-column pb-4">
                  <div class="text-center mb-2">
                    <i class="zmdi zmdi-card zmdi-hc-3x"></i>
                  </div>
                  <div class="text-center mb-2">
                    <div class="fw-bold mb-1 h5">David Beckham</div>
                    <div class="text-muted">2587-XXXX-2525-4568</div>
                  </div>
                </div>
                <div class="border-top text-center pt-3">
                  Expires at 07/18
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-md-6">
              <div class="card mb-4">
                <div class="card-body text-center">
                  <div class="circle">
                    <img class="rounded-circle img-thumbnail" src="assets/images/sm/avatar1.jpg" alt="">
                  </div>
                  <h6 class="mt-3 mb-0">Michelle Green</h6>
                  <span>jason-porter@info.com</span>
                  <ul class="mt-3 list-unstyled d-flex justify-content-center">
                    <li><a class="p-3" target="_blank" href="javascript:void(0);"><i class="zmdi zmdi-facebook"></i></a>
                    </li>
                    <li><a class="p-3" target="_blank" href="javascript:void(0);"><i
                          class="zmdi zmdi-linkedin-box"></i></a></li>
                    <li><a class="p-3" target="_blank" href="javascript:void(0);"><i class="zmdi zmdi-linkedin"></i></a>
                    </li>
                  </ul>
                  <button class="btn btn-default btn-sm">Follow</button>
                  <button class="btn btn-default btn-sm">Message</button>
                </div>
              </div>
              <div class="card text-center pt-3">
                <div class="card-body">
                  <div class="card-user-avatar">
                    <img src="assets/images/user.png" alt="avatar">
                    <button type="button" class="btn btn-secondary btn-sm"><i class="zmdi zmdi-edit"></i></button>
                  </div>
                  <div class="card-user-detail mt-4">
                    <h6>Michelle Green</h6>
                    <span class="text-muted">michelle.green@gmail.com</span>
                    <p>+14 123 456 789</p>
                    <div class="social">
                      <a class="icon p-2" href="javascript:void(0);" data-bs-toggle="tooltip" title=""
                        data-original-title="Facebook"><i class="zmdi zmdi-facebook-box"></i></a>
                      <a class="icon p-2" href="javascript:void(0);" data-bs-toggle="tooltip" title=""
                        data-original-title="Github"><i class="zmdi zmdi-github-box"></i></a>
                      <a class="icon p-2" href="javascript:void(0);" data-bs-toggle="tooltip" title=""
                        data-original-title="Linkedin"><i class="zmdi zmdi-linkedin-box"></i></a>
                      <a class="icon p-2" href="javascript:void(0);" data-bs-toggle="tooltip" title=""
                        data-original-title="Instagram"><i class="zmdi zmdi-instagram"></i></a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4 border-0 bg-success text-white">
                <div class="card-body">
                  <div class="d-flex flex-wrap align-items-center">
                    <i class="zmdi zmdi-dns zmdi-hc-3x me-3"></i>
                    <div>
                      <div class="h5 mb-0 fw-bold">Databases</div>
                      <div class="small">Total: 25,145</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4 border-0 bg-primary text-white">
                <div class="card-body">
                  <div class="d-flex flex-wrap align-items-center">
                    <i class="zmdi zmdi-eye zmdi-hc-3x me-3"></i>
                    <div>
                      <div class="h5 mb-0 fw-bold">Pageviews</div>
                      <div class="small">Total: 53,145</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4 border-0 bg-warning text-white">
                <div class="card-body">
                  <div class="d-flex flex-wrap align-items-center">
                    <i class="zmdi zmdi-globe zmdi-hc-3x me-3"></i>
                    <div>
                      <div class="h5 mb-0 fw-bold">68.05%</div>
                      <div class="small">Avg. Click Rate</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-4">
                <div class="card-body">
                  <div class="d-flex flex-wrap flex-column align-items-center">
                    <div class="mb-3">
                      <img src="assets/images/sm/avatar3.jpg" class="rounded-circle img-thumbnail" alt="profile-image">
                    </div>
                    <div class="text-center">
                      <div class="fw-bold">Helen Maggie</div>
                      <div class="text-uppercase small mb-3">Support team</div>
                      <button class="btn btn-primary"><i class="zmdi zmdi-plus"></i> Request Access</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>

</div>
<!-- Main Body: Content -->
